export const MapLeafletContainerStyles = {
    Holder: {
        width: '100%',
        height: '100vh',
        overflow: 'hidden',
    },
    HolderLocked: {
        position: 'absolute',
        top: 0,
        width: '100%',
        height: '100vh',
        overflow: 'hidden',
        zIndex: 2000,
    },
} as const;
